<div class="pointCF__field">
  <label
    ppTooltip
    class="pointCF__label"
    ppTitle="{{ ppCustomField?.label }}"
    [ppTrimTooltip]="true"
  >
    <img class="pointCF__bulk-changes-field-icon" [src]="EIconPath.CUSTOM_FIELD_NUMBERS_ACTIVITY" />

    <span class="pointCF__label-container">
      {{ ppCustomField?.label }}
    </span>
  </label>

  <pp-custom-field-cost
    ppTooltip
    [ppTitle]="tooltipText"
    [ppCanEdit]="!ppCustomField.subValuesActive && !disabled"
    [ppWorkspaceId]="ppCustomField.workspaceId"
    [ppFieldId]="ppCustomField.id"
    [ppFieldLabel]="ppCustomField.label"
    ppFieldCurrencySymbol=""
    [ppFieldCurrencyCode]="ppCustomField.unit"
    [ppCurrencyName]="unitName"
    [ppFieldValue]="'' + ppCustomFields[ppFieldId]"
    [ppDecimalPlaces]="+ppCustomField.decimalPlaces"
    [ppNew]="false"
    (ppUpdate)="updateNumbers($event, ppCustomField)"
    [ppIsLocked]="ppCustomField.lockedValue"
  ></pp-custom-field-cost>
</div>
